import { API } from "../../../config";
import AxiosUtils from "../../../utils/AxiosUtils";
import { mockAPIPath, serverAPIPath } from "../config/apiPath";
import Cookies from "../../../utils/Cookies";
import { AdminNoteType } from "../../../interfaces/adminNoteInterface";


class adminNoteService {
    private payload: object;
    private isHitDummyURL: boolean;
    private headers: object;

    constructor(payload = {}, isHitDummyURL = false) {
        this.payload = payload;
        this.isHitDummyURL = isHitDummyURL;
        this.headers = { "access-token": new Cookies("access-token").read() };
    }
    
    async adminNoteGet(id: any) {
        const response = this.isHitDummyURL
            ? await new AxiosUtils(
                `${mockAPIPath.ADMIN_NOTE}`,
                this.payload,
                this.headers
            ).get()
            : await new AxiosUtils(
                `${API.BASE_URL}${serverAPIPath.ADMIN_NOTE}/${id}`,
                this.payload,
                this.headers
            ).get();
        if (response?.data?.success) {
            const cancelOrderReasonData: AdminNoteType[] = response?.data?.data;
            return cancelOrderReasonData;
        } else if (response?.success == false) {
            throw new Error(response?.message);
        } else {
            throw new Error(response);
        }
    }

    async AdminNotePost() {
        const response = this.isHitDummyURL
            ? await new AxiosUtils(
                `${mockAPIPath.ADMIN_NOTE}`,
                this.payload,
                this.headers
            ).get()
            : await new AxiosUtils(
                `${API.BASE_URL}${serverAPIPath.ADMIN_NOTE}`,
                this.payload,
                this.headers
            ).post();
        let responseMessage: string;
        if(response?.data?.success==true) {
            responseMessage = response?.data?.message;
            return responseMessage;
        }
        else if(response?.success == false)
        {   
            throw new Error(response?.message);        
        }else{
            throw new Error(response);
        }
    }

}
export default adminNoteService;